export default __webpack_public_path__ + "static/media/family.5bef9950.jpg";